// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import tool01Icon from "@/assets/icons/tool-01.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type Tool01IconProps = Omit<IconProps, "name">;

export function Tool01Icon(props: Tool01IconProps): React.ReactNode {
  return <Icon name={tool01Icon} {...props} />;
}
